export default {
  EPISODE: 'episode',
  SEASON: 'season',
  COMMON_PUBLISHYEAR: 'common_publishyear',
  SYNOPSIS: 'finPlayer_Ser_synopsis',
  MORE_INFO: 'common_mas_info',
  GROUP_BUTTON_ADDFAN: 'grupo_button_addFan',
};
